import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import cn from 'classnames';
import CreateButton from 'routes/App/menuEditor/HeadLine/CreateButton';
import PublishButton from 'routes/App/menuEditor/HeadLine/PublishButton';
import Headline from 'components/Headline/styles';
import IconAdd from 'assets/IconAdd';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';
import {OPEN_PRICE_ADJUSTMENT_MODAL} from 'store/platformPriceAdjustments/action';
import {FEATURE_RESTRICTION_IDS} from '../../../../helpers/constants/restrictions';

export default function HeadLine() {
  const dispatch = useDispatch();
  const buttonScrollTopLimit = 0;
  const [buttonIsFixed, setButtonIsFixed] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const activeLocation = useSelector((state) => state.user.activeLocation);

  useEffect(() => {
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
      setButtonIsFixed(
        e.target.documentElement.scrollTop > buttonScrollTopLimit
      );
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop]);

  const handleOpenModal = () => {
    dispatch(OPEN_PRICE_ADJUSTMENT_MODAL());
  };

  return (
    <Headline className='HeadLineMenu'>
      Menu Editor
      <div
        className={cn('buttons', {
          isFixed: buttonIsFixed
        })}
      >
        <PublishButton />
        {activeLocation?.AllowedServiceFeatures?.includes(
          FEATURE_RESTRICTION_IDS.MENU_PRICE_ADJUST
        ) && (
          <ButtonPrimary
            onClick={handleOpenModal}
            className='ButtonMedium ButtonAdd'
          >
            <span>Adjust Price</span>
          </ButtonPrimary>
        )}
        <CreateButton />
      </div>
    </Headline>
  );
}
